import { Card } from "antd"
import { type CardProps } from "antd/lib/card"

import { cn } from "../../utils/cn.ts"

export function CardComponent({ className, ...rest }: CardProps) {
  return <Card className={cn("shadow-card", className)} {...rest} />
}
